import { render, staticRenderFns } from "./altaCupones.vue?vue&type=template&id=9fd7cd12&scoped=true"
import script from "./altaCupones.vue?vue&type=script&lang=js"
export * from "./altaCupones.vue?vue&type=script&lang=js"
import style0 from "./altaCupones.vue?vue&type=style&index=0&id=9fd7cd12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd7cd12",
  null
  
)

export default component.exports